'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    IdleScrollMixin = require('../mixins/IdleScrollMixin'),
    TransitionEventsMixin = require('../mixins/TransitionEventsMixin'),
    forceUpdateBodyOverflow = require('../utils/forceUpdateBodyOverflow'),
    { PropTypes } = React;

require('./Sidebar.less');

var Sidebar = React.createClass({
  mixins: [ClassNameMixin, IdleScrollMixin, TransitionEventsMixin, PureRenderMixin],

  propTypes: {
    active: PropTypes.bool
  },

  getInitialState() {
    return this.getStateFromProps(this.props);
  },

  getCSSModifiers() {
    return {
      active: this.state.active
    };
  },

  getStateFromProps(props) {
    return {
      active: props.active,
      children: props.children
    };
  },

  /**
   * We maintain `active` and `children` in `state`
   * in order to perform UI optimizations such as:
   *
   * - on open, first draw children and then trigger transition
   * - on close, leave children until transition is over
   */
  reconcileStateWithProps(props) {
    this.setState(this.getStateFromProps(props));
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.active === this.props.active) {
      // Children changed, active has not. Reconcile now.
      this.reconcileStateWithProps(nextProps);
      return;
    }

    if (!this.props.active && nextProps.active) {
      // Becoming active. Reconcile after children are rendered.
      this._needsReconcileStateAfterDOMFlush = true;
      this.setState({ active: false, children: nextProps.children });
      return;
    }

    if (this.props.active && !nextProps.active) {
      // Becoming inactive. Will reconcile when CSS transition ends.
      this.setState({ active: false });
      return;
    }
  },

  componentDidUpdate() {
    if (this._needsReconcileStateAfterDOMFlush) {
      this._needsReconcileStateAfterDOMFlush = false;
      this.reconcileStateWithProps(this.props);
    }
  },

  render() {
    var className = this.getClassName();
    if (this.isScrolling()) {
      className += ' utils--scrolling';
    }

    return (
      <div className={className}
           onScroll={this.handleScroll}
           onTransitionEnd={this.handleTransitionEnd}>
        {this.state.children}
      </div>
    );
  },

  handleTransitionEnd() {
    this.reconcileStateWithProps(this.props);
    forceUpdateBodyOverflow();
  }
});

module.exports = Sidebar;


/** WEBPACK FOOTER **
 ** ./organisms/Sidebar.jsx
 **/